import { AlertCenterCheckResponse } from '@goldcast/api/backend';

import { FormattedAlertForEntityItems, State } from './types';

const mutations = {
  setAlertCenterChecks(state: State, alertCenterChecks: AlertCenterCheckResponse) {
    state.alertCenterChecks = alertCenterChecks;
  },
  setFormattedEntityMappedAlerts(state: State, formattedAlertForEntityItems: FormattedAlertForEntityItems) {
    state.formattedEntityMappedAlerts = formattedAlertForEntityItems;
  }
};

export default mutations;
